import {
  Box,
  Text,
  VStack,
  HStack,
  Link,
  Divider,
  SimpleGrid,
  Icon,
} from "@chakra-ui/react";
import { PhoneIcon, EmailIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
// import { useEffect, useState } from "react";
// import { fetchTotal } from "../api/api";
// import CountUp from "react-countup";

const quickLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Deeds", path: "/deeds" },
  { label: "Expenditures", path: "/expenditures" },
  { label: "Contact", path: "/contact" },
];

export default function Footer() {
  const navigate = useNavigate();

  // const [total, setTotal] = useState(0);

  // useEffect(() => {
  //   fetchTotal()
  //     .then((res) => setTotal(res.data))
  //     .catch(console.error);
  // }, []);

  // const formatINR = (value) =>
  //   new Intl.NumberFormat("en-IN", {
  //     style: "currency",
  //     currency: "INR",
  //     maximumFractionDigits: 0,
  //   }).format(value);

  return (
    <Box bg="saffron.500" color="white" pt={12} pb={6} px={4} mt={12}>
      {/* ✅ Commented out total feature (can re-enable later) */}
      {/*
      <Box position="absolute" top={2} right={4}>
        <Text bg="white" color="green.700" fontWeight="bold" px={3} py={1} borderRadius="md" boxShadow="md">
          Total Collected:{" "}
          <CountUp end={total} duration={5} separator="," formattingFn={formatINR} />
        </Text>
      </Box>
      */}

      <Box maxW="1100px" mx="auto">
        {/* ── Column layout — temples.bio style ── */}
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10} mb={10}>
          {/* Column 1 — Temple identity */}
          <VStack
            align={{ base: "center", md: "start" }}
            spacing={3}
            textAlign={{ base: "center", md: "left" }}
          >
            <Text fontWeight="700" fontSize="md" lineHeight="1.6">
              శ్రీ అన్నపూర్ణ సమేత విశ్వేశ్వర స్వామి ఆలయ కమిటీ
            </Text>
            <Text fontSize="xs" opacity={0.85} lineHeight="1.8">
              A community-run temple in Thokada, dedicated to transparent
              construction and devotee-first service.
            </Text>
          </VStack>

          {/* Column 2 — Quick Links */}
          <VStack align={{ base: "center", md: "start" }} spacing={2}>
            <Text
              fontWeight="700"
              fontSize="sm"
              letterSpacing="0.05em"
              textTransform="uppercase"
              mb={1}
            >
              Quick Links
            </Text>
            {quickLinks.map((item) => (
              <Link
                key={item.label}
                onClick={() => navigate(item.path)}
                fontSize="sm"
                opacity={0.9}
                _hover={{ opacity: 1, textDecoration: "underline" }}
              >
                {item.label}
              </Link>
            ))}
          </VStack>

          {/* Column 3 — Contact */}
          <VStack align={{ base: "center", md: "start" }} spacing={3}>
            <Text
              fontWeight="700"
              fontSize="sm"
              letterSpacing="0.05em"
              textTransform="uppercase"
              mb={1}
            >
              Contact Us
            </Text>
            <Text
              fontSize="sm"
              opacity={0.9}
              lineHeight="1.8"
              textAlign={{ base: "center", md: "left" }}
            >
              తోకాడ గ్రామం, రాజమహేంద్రవరం,
              <br />
              తూర్పు గోదావరి జిల్లా, ఆంధ్రప్రదేశ్ – 533296
            </Text>
            <HStack spacing={2}>
              <Icon as={PhoneIcon} boxSize={3} />
              <Link
                href="tel:+919493575676"
                fontSize="sm"
                _hover={{ textDecoration: "underline" }}
              >
                +91 9493575676
              </Link>
            </HStack>
            <HStack spacing={2}>
              <Icon as={EmailIcon} boxSize={3} />
              <Link
                href="mailto:sasvsathokada@gmail.com"
                fontSize="sm"
                _hover={{ textDecoration: "underline" }}
              >
                sasvsathokada@gmail.com
              </Link>
            </HStack>
          </VStack>
        </SimpleGrid>

        <Divider borderColor="whiteAlpha.300" mb={5} />

        {/* Bottom bar */}
        <Text fontSize="xs" opacity={0.65} textAlign="center">
          © 2026 Sri Annapurna Sametha Visweswara Swamy Alayam, Thokada.
          Developed by NV Tech &amp; Arrays Global Services India
        </Text>
      </Box>
    </Box>
  );
}
